var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Inset } from "syf-component-library/ui/spacing";
import useWindowSize from "syf-component-library/ui/customHooks/useWindowWidth";
import { DesktopCardContainer } from "../../ui/layouts/DesktopCard/DesktopCard.styles";
import { MobileCardContainer } from "../../ui/layouts/MobileCard/MobileCard.styles";
import { CollapsedSkeletonLoader, SkeletonLoader, SkeletonLoaderWrapper, } from "./LoadingWrapper.styles";
var LoadingWrapper = function (_a) {
    var isLoading = _a.isLoading, children = _a.children;
    var windowWidth = useWindowSize();
    if (isLoading) {
        return (_jsx(SkeletonLoaderWrapper, __assign({ "data-testid": "skeleton-loader" }, { children: !windowWidth.isLessThanMobile ? (_jsx(DesktopCardContainer, __assign({ "data-testid": "desktop-card-container" }, { children: _jsx(Inset, __assign({ vertical: "base" }, { children: _jsx(SkeletonLoader, {}) })) }))) : (_jsx(MobileCardContainer, __assign({ "data-testid": "mobile-card-container" }, { children: _jsx(Inset, __assign({ vertical: "base" }, { children: _jsx(CollapsedSkeletonLoader, {}) })) }))) })));
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return _jsx(_Fragment, { children: children });
};
export default LoadingWrapper;
//# sourceMappingURL=LoadingWrapper.js.map